import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// F-ORÇAMENTOS.6 — toggle "Sem data definida" + modo de cálculo (noites estimadas | valor manual)
export const SemDataFields = ({ form, setForm, prefix = "orc", noitesDasDatas = 0 }) => {
  const set = (patch) => setForm({ ...form, ...patch });
  // Ao marcar "sem data", reaproveita as noites das datas atuais só se não houver estimativa.
  const toggle = (checked) => set({
    sem_data: checked,
    noites_estimadas: checked && !form.noites_estimadas && noitesDasDatas > 0
      ? String(noitesDasDatas) : form.noites_estimadas,
  });
  return (
    <div className="space-y-3" data-testid={`${prefix}-sem-data-box`}>
      <label className="inline-flex items-center gap-2 text-sm cursor-pointer">
        <input type="checkbox" checked={!!form.sem_data} data-testid={`${prefix}-toggle-sem-data`}
          onChange={(e) => toggle(e.target.checked)} />
        Sem data definida (cliente ainda vai escolher as datas)
      </label>
      {form.sem_data && (
        <div className="rounded-md border border-stone-200 bg-stone-50 p-3 space-y-3">
          <div className="flex flex-wrap gap-2">
            {[["noites", "Por noites estimadas"], ["manual", "Valor total manual"]].map(([k, l]) => (
              <button key={k} type="button" data-testid={`${prefix}-modo-valor-${k}`}
                onClick={() => set({ modo_valor: k })}
                className={`px-3 py-1.5 rounded-md border text-xs font-medium transition-colors ${
                  form.modo_valor === k ? "bg-[#083A6B] text-white border-[#083A6B]" : "bg-white text-stone-600 border-stone-200 hover:bg-stone-100"}`}>
                {l}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <Label className="text-xs">Noites estimadas{form.modo_valor === "noites" ? " *" : " (opcional)"}</Label>
              <Input type="number" min="0" inputMode="numeric" value={form.noites_estimadas}
                data-testid={`${prefix}-input-noites-estimadas`}
                onChange={(e) => set({ noites_estimadas: e.target.value })} />
            </div>
            {form.modo_valor === "manual" && (
              <div>
                <Label className="text-xs">Valor total da hospedagem (R$) *</Label>
                <Input type="number" min="0" step="0.01" inputMode="decimal" value={form.valor_hospedagem_manual}
                  data-testid={`${prefix}-input-valor-manual`}
                  onChange={(e) => set({ valor_hospedagem_manual: e.target.value })} />
              </div>
            )}
          </div>
          {form.modo_valor === "manual" && !(Number(form.noites_estimadas) > 0) && (
            <div className="text-[11px] text-[#8B6A1F]" data-testid={`${prefix}-aviso-cafe-sem-noites`}>
              Sem noites estimadas, o café da manhã não é somado (inclua no valor total, se for o caso).
            </div>
          )}
          <div className="text-[11px] text-stone-500 italic">
            No PDF aparecerá: "Datas da hospedagem: a definir pelo cliente". Para converter em reserva, informe as datas depois.
          </div>
        </div>
      )}
    </div>
  );
};

export const periodoOrcamento = (o, fmtDate) => {
  if (o?.sem_data) {
    const n = Number(o.noites_estimadas || 0);
    return n ? `Datas a definir · ${n} noite(s) estimada(s)` : "Datas a definir";
  }
  return `${fmtDate(o?.data_entrada)} → ${fmtDate(o?.data_saida)}`;
};
